import { Link } from "react-router-dom";
import "./Sidebar.css";

const Sidebar = () => {
  return (
    <aside className="admin-sidebar">

      <h2 className="admin-sidebar-title">
        Admin Panel
      </h2>

      <nav className="admin-sidebar-menu">

        <Link to="/admin">
          Dashboard
        </Link>

        <Link to="/admin/contact">
          Contact
        </Link>

        <Link to="/admin/services">
          Services
        </Link>
        
        <Link to="/admin/contactenquiry">
        Contact Enquiries
      </Link>

        <Link to="/admin/branding">
          Branding Case Study
        </Link>

        <Link to="/admin/digital">
          Digital Marketing Case Study
        </Link>

      </nav>

    </aside>
  );
};

export default Sidebar;